import PageWrap from '../../components/layout/PageWrap'
import FormWrap from '../../components/forms/FormWrap'
import FormBlock from '../../components/forms/FormBlock'
import { Form } from 'antd'

import {
    TemplateDescription,
    TemplateArea,
    cleanBeforeSendingTemplate,
} from '../../constants/forms/Delivery'
import { CreateDeliveryTemplates as request } from '../../network/API'

const CreateDeliveryTemplate = () => {
    const [form] = Form.useForm()

    return (
        <PageWrap goBack title="DELIVERY_TEMPLATES_CREATE_TEMPLATE">
            <FormWrap
                form={form}
                title="create_template"
                request={request}
                cleanBeforeSending={cleanBeforeSendingTemplate}
                onSuccess={'/delivery'}
                onCancel={'/delivery'}
                invalidate={['getDeliveryTemplates']}
            >
                <div className="SectionVerticalWrap">
                    <FormBlock form={form} formTemplate={TemplateDescription} />
                    <FormBlock formTemplate={TemplateArea} />
                </div>
            </FormWrap>
        </PageWrap>
    )
}

export default CreateDeliveryTemplate
